import Vue from 'vue'

Vue.component('iot-widget-ignition', () => import('./Ignition.vue'))
Vue.component('iot-widget-brake-test-state', () => import('./BrakeTestState.vue'))
Vue.component('iot-widget-iot-device-powered-by-asset-l-1', () => import('./IotDevicePoweredByAssetL1.vue'))
Vue.component('iot-widget-machine-ignition-on', () => import('./MachineIgnitionOn.vue'))
Vue.component('iot-widget-machine-overload', () => import('./MachineOverload.vue'))
Vue.component('iot-widget-machine-fault', () => import('./MachineFault.vue'))
Vue.component('iot-widget-device-temperature', () => import('./DeviceTemperature.vue'))
Vue.component('iot-widget-device-humidity', () => import('./DeviceHumidity.vue'))
Vue.component('iot-widget-run-time', () => import('./RunTime.vue'))
Vue.component('iot-widget-battery-voltage', () => import('./BatteryVoltage.vue'))
Vue.component('iot-widget-unit-powered', () => import('./UnitPowered.vue'))
Vue.component('iot-widget-380-v-220-v-power-supply', () => import('./380V220VPowerSupply.vue'))
Vue.component('iot-widget-fire-signal', () => import('./FireSignal.vue'))
Vue.component('iot-widget-24-v-dc-psu', () => import('./24VDCPSU.vue'))
